export const truncateFileName = (
  fileName: string | null | undefined,
  maxBaseLength = 20,
) => {
  if (!fileName) return "";

  const trimmedFileName = fileName.trim();
  const lastDotIndex = trimmedFileName.lastIndexOf(".");

  if (lastDotIndex <= 0 || trimmedFileName.length <= maxBaseLength) {
    return trimmedFileName;
  }

  const extension = trimmedFileName.slice(lastDotIndex);
  const baseName = trimmedFileName.slice(0, lastDotIndex);

  if (baseName.length <= maxBaseLength) {
    return trimmedFileName;
  }

  return `${baseName.slice(0, maxBaseLength)}...${extension}`;
};
